<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="题目类型">
                    <el-select v-model="form.type" clearable placeholder="题目类型">
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划分值" style="color:red;">
                    {{ planTotalScore }}
                </el-form-item>
                <el-form-item label="题库分值" style="color:red;">
                    {{ questionBankTotalScore }}
                </el-form-item>
            </el-form>
            <div style="display:flex;justify-content:flex-end">
                <el-input placeholder="请输入" v-model="score" style="margin-right: 10px;width: 300px">
                    <template slot="prepend">批量分数</template>
                </el-input>
                <el-button type="primary" @click="batchSet()">批量设置</el-button>
                <el-button type="primary" @click="batchSave()">保存</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="questionContent"
                    label="题目">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="statusName"
                    label="类型">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="answer"
                    label="答案">
                </el-table-column>
                <el-table-column
                    label="分数"
                    min-width="180">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.score"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
export default {
    props: [
        "attr"
    ],
    data() {
        return {
            form: {
                type: '',
                examId: (this.attr && this.attr.examId) ? this.attr.examId : null,
            },
            tableData: [],
            lessonTypes: [],
            questionBankTotalScore: 0,
            planTotalScore: 0,
            score: 0,
        }
    },
    watch: {
        "form": {
            handler: function (newValue) {
                this.loadData();
            },
            deep: true
        }
    },
    methods: {
        loadData() {
            this.$ajaxPost("/question/listQuestion", {
                form: this.form,
            }, (data) => {
                this.tableData = data.result;
                this.loadTotalScore();
            })
        },
        loadTotalScore() {
            this.$ajaxPost("/question/getTotalScore/" + this.form.examId, {}, (data) => {
                if (data && data.success) {
                    this.planTotalScore = data.result.planTotalScore;
                    this.questionBankTotalScore = data.result.questionBankTotalScore;
                }
            })
        },
        loadLessonTypes() {
            this.$ajaxGet("/question/lessonType", (data) => {
                if (data && data.success && data.result) {
                    this.lessonTypes.push(...data.result);
                }
            })
        },
        batchSave() {
            this.$ajaxPost("/question/batchEditScore", {
                questionList: this.tableData
            }, (data) => {
                if (data && data.success) {
                    this.loadTotalScore();
                    this.$showSuccess("操作成功");
                }
            })
        },
        batchSet(){
            for(let i = 0 ; i < this.tableData.length ; i++){
                this.tableData[i].score = this.score;
            }
        },
    },
    created() {
        this.loadData();
        this.loadLessonTypes();
    }
}
</script>
